import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/CalculatorCellulose.jsx';

export default define`Cellulose Calculator`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/CalculatorCellulose`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
